import { AnimatedSection } from '@/components/ui';

const INTEGRATION_LOGOS = [
  { name: 'Shopify',     slug: 'shopify'     },
  { name: 'WordPress',   slug: 'wordpress'   },
  { name: 'Squarespace', slug: 'squarespace' },
  { name: 'Wix',         slug: 'wix'         },
] as const;

// Pinned version — unpkg `@latest` redirects to 16.18.0 (verified 2026-04-29).
// Pinning prevents surprise cache invalidation when Simple Icons publishes new versions.
const ICONS_BASE = 'https://unpkg.com/simple-icons@16.18.0/icons';

export const TrustBar = () => {
  return (
    <AnimatedSection className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 py-8 border-y border-border">
      <span className="text-sm text-muted-foreground font-medium whitespace-nowrap">
        Works with
      </span>
      <div className="flex items-center gap-6 md:gap-8">
        {INTEGRATION_LOGOS.map(({ name, slug }) => (
          <img
            key={slug}
            src={`${ICONS_BASE}/${slug}.svg`}
            alt={name}
            width={32}
            height={32}
            className="h-7 w-auto opacity-50 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-200"
          />
        ))}
      </div>
    </AnimatedSection>
  );
};
